enum MintType {
  Airdrop = "Airdrop",
  Pnft = "Pnft",
  Regular = "Regular",
}

export default MintType;
